import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import modalPlugin from './plugins/modalPlugin';
import FTS from '@/filters';
import utils from '@/utils';
import * as DIR from '@/directives';

import 'bootstrap/dist/css/bootstrap.css';
import "@/assets/css/font.css";
import "@/assets/css/animation.css";
import "@/assets/css/transition.css";
import "@/assets/css/hamburger.css";
import '@/assets/css/style.css';
import 'bootstrap/js/src/collapse.js';

import { LocalizationServices } from './services/LocalizationServices';

const app = createApp(App)
    .use(store)
    .use(router)
    .use(modalPlugin)
    .directive("localizedPlaceholder", DIR.localizedPlaceholderDirective);

app.config.globalProperties.$filters = FTS;
app.config.globalProperties.$localizationService = LocalizationServices;
app.config.globalProperties.$utils = utils;

router.beforeEach((to, from, next) => {        
    next();

    var el = document.getElementById("formContainerScrollable");
    if(el) {
        window.scrollTo(0, el.scrollTop);
        el.scrollTop = 0;
    }
})

//questo aggiunge automaticamente ogni componente nella cartella 'components'
const ComponentContext = require.context('./components', true, /\.vue$/i);
ComponentContext.keys().forEach(fileName => {
    var component = ComponentContext(fileName);
    let componentName = fileName.split('/').pop().split('.')[0];
    app.component(componentName, (<any>component).default || component);
})

app.mount('#app');
